import axios from 'axios'
import {clearTokensAndRedirect, getAccessToken} from "./tokenService";
import {myAcademySlug} from "@/lib/services/academyService";


export const getAuthToken = () => {
    const token = getAccessToken()
    return `Bearer ${token}`
}

const addHeaderInterceptor = (instance) => {
    instance.interceptors.request.use(
        (config) => {
            config.headers.Authorization = getAuthToken()
            config.headers['X-Academy'] = myAcademySlug()

            return config
        },
        (e) => {
            return Promise.reject(e)
        },
    )
}

const addRequestInterceptor = (instance) => {
    instance.interceptors.request.use(
        (config) => {
            // config.data = snakize(config?.data)
            return config
        },
        (e) => {
            return Promise.reject(e)
        },
    )
}

const addResponseInterceptor = (instance) => {
    instance.interceptors.response.use(
        (res) => {
            // if (res && res.data) return camelize(res.data)
            // if (res && res.data) return res.data
            return res
        },
        (e) => {

            if (e?.response?.status === 401 && !e?.request?.responseURL.endsWith('auth/authenticate')) {

                clearTokensAndRedirect()

            }
            return Promise.reject(e)
        },
    )
}
const createPureInstance = (baseUrl, {headers, ...configs} = {}) => {
    return axios.create({
        timeout: 45000,
        baseURL: baseUrl,
        headers: {
            ...(headers || {}),
        },
        maxRedirects: 5,
        insecureHTTPParser: true,
        ...configs,
    })
}

const createInstance = (baseUrl, configs = {}) => {
    const instance = createPureInstance(baseUrl, configs)

    addHeaderInterceptor(instance)
    addResponseInterceptor(instance)
    addRequestInterceptor(instance)

    return instance
}


export {createPureInstance, createInstance}
